/** 수량: NUMERIC(24,6) 문자열 — 뒤 0을 정리하고 천단위 구분 (저장값은 건드리지 않음, 6.2) */
export function fmtQty(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  const s = String(value);
  const [int, frac = ""] = s.split(".");
  const trimmed = frac.replace(/0+$/, "");
  const intFmt = Number(int).toLocaleString("ko-KR");
  return trimmed ? `${intFmt}.${trimmed}` : intFmt;
}

/** 원화: NUMERIC(18,0) */
export function fmtKrw(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return `${Number(value).toLocaleString("ko-KR")}원`;
}

export function fmtUsdt(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return `${Number(value).toLocaleString("ko-KR")} USDT`;
}

export function fmtDate(value: string | null | undefined): string {
  return value ? value.slice(0, 10) : "—";
}
